export const PAGE_NAME = 'HelpPage';
